import {HttpClient, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {HttpService} from "app/misc/http.service";
import { environment } from "environments/environment";
import { retry } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class BroadcastService {

    private readonly REPORT_BASE_URL = `${environment.BASE_URL}/cmp-report`;
    private readonly AUTH_BASE_URL = `${environment.BASE_URL}/cmp-auth`;

    constructor(private http: HttpClient) {}
    listMessageFor = () => this.http.get(`${this.REPORT_BASE_URL}/v2/broadcast/list-messages-for`).pipe(retry(2));

    getBroadcastById = (id) => this.http.get(`${this.REPORT_BASE_URL}/v2/broadcast/broadcast/${id}`).pipe(retry(2));

    deleteBroadcastById = (id) =>
        this.http.delete(`${this.AUTH_BASE_URL}/v2/broadcast/delete-broadcast/${id}`).pipe(retry(2));

    fetchBroadcast = (page?: number, pageSize?: number) => {
        let params = new HttpParams();
        if (page) {
            params = params.append("page", page);
        }
        if (pageSize) {
            params = params.append("pageSize", pageSize);
        }
        return this.http.get(`${this.REPORT_BASE_URL}/v2/broadcast/broadcasts`, {params}).pipe(retry(2));
    };

    createBroadcast = (data) =>
        this.http.post(`${this.AUTH_BASE_URL}/v2/broadcast/create-broadcast`, data).pipe(retry(2));
}
